"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookmarksVisibility = exports.ConflictNameAction = exports.BookmarksSettings = void 0;
var BookmarksSettings = (function () {
    function BookmarksSettings() {
        this.conflictNameResolution = ConflictNameAction.Rename;
        this.visibility = BookmarksVisibility.Auto;
        this.color = "rgb(127, 127, 127)";
    }
    BookmarksSettings.prototype.copyFrom = function (obj) {
        this.conflictNameResolution = obj.conflictNameResolution;
        this.visibility = obj.visibility;
        this.color = obj.color;
    };
    BookmarksSettings.prototype.clone = function () {
        var result = new BookmarksSettings();
        result.copyFrom(this);
        return result;
    };
    return BookmarksSettings;
}());
exports.BookmarksSettings = BookmarksSettings;
var ConflictNameAction;
(function (ConflictNameAction) {
    ConflictNameAction[ConflictNameAction["Keep"] = 0] = "Keep";
    ConflictNameAction[ConflictNameAction["Rename"] = 1] = "Rename";
    ConflictNameAction[ConflictNameAction["Skip"] = 2] = "Skip";
})(ConflictNameAction = exports.ConflictNameAction || (exports.ConflictNameAction = {}));
var BookmarksVisibility;
(function (BookmarksVisibility) {
    BookmarksVisibility[BookmarksVisibility["Auto"] = 0] = "Auto";
    BookmarksVisibility[BookmarksVisibility["Visible"] = 1] = "Visible";
    BookmarksVisibility[BookmarksVisibility["Hidden"] = 2] = "Hidden";
})(BookmarksVisibility = exports.BookmarksVisibility || (exports.BookmarksVisibility = {}));
